import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { logger } from '@/utils/logger'

import { ApiTaRe240 } from '~/endpoints/ApiTaRe240'

// State type
// 実力テスト教科別成績取得（志望校判断）
interface TestSubjectRecord {
  placementTestReportSubject: {
    partNumber: string
    questionNumber: string
    difficulity: string
    allocation: string
    score: string
    average: string
  }[]
}
const getEmptyTestSubjectRecord = (): TestSubjectRecord => ({
  placementTestReportSubject: [],
})

// 実力テスト教科別成績取得（志望校判断）
interface ActionParamsTestSubjectRecord {
  subjectCode: string
  fiscalYear: number
  grade: number
  testMonth: number
  testCount?: number
  courseId: string
}

@Module({
  stateFactory: true,
  namespaced: true,
  name: 'apis/DetermineSchoolSubject',
})
export default class DetermineSchoolSubject extends VuexModule {
  // States
  private testSubjectRecord_ = getEmptyTestSubjectRecord()

  // Getters
  // 実力テスト教科別成績取得（志望校判断）
  get testSubjectRecord(): TestSubjectRecord {
    return this.testSubjectRecord_
  }

  // Mutations
  @Mutation
  updateTestSubjectRecord(value: TestSubjectRecord) {
    this.testSubjectRecord_ = value
  }

  @Action
  clear() {
    this.context.commit('updateTestSubjectRecord', getEmptyTestSubjectRecord())
  }

  @Action
  async getTestSubjectRecord(param: ActionParamsTestSubjectRecord) {
    logger.trace('in: getTestSubjectRecord')
    const api = new ApiTaRe240.Api()

    // API: ApiTaRe240
    const result = await api.get<TestSubjectRecord | null>(
      {
        query: {
          subjectCode: param.subjectCode,
          fiscalYear: param.fiscalYear,
          grade: param.grade,
          testMonth: param.testMonth,
          testCount: param.testCount,
          courseId: param.courseId,
        },
      },
      // Success
      (data, _) => {
        return {
          placementTestReportSubject: data.placementTestReportSubject,
        }
      },
      // Error
      (data, status) => {
        logger.error(status, data)
        return null
      }
    )
    if (result === null) {
      return
    }
    this.context.commit('updateTestSubjectRecord', result)
  }
}
